<template>
  <div>
    <!-- eslint-disable -->
    <div id="fb-root"></div>

    <div class="fb-customerchat"
      attribution=install_email
      page_id="356110381869834"
      theme_color="#d1ae68"
        logged_in_greeting="Miben segíthetünk? 👰🤵📷"
        logged_out_greeting="Miben segíthetünk? 👰🤵📷">
    </div>
     <!-- eslint-enable -->
  </div>
</template>

<script>
export default {
  name: 'ThePageFbChat',
  mounted() {
    /* eslint-disable */
    window.fbAsyncInit = function() {
      FB.init({
        xfbml            : true,
        version          : 'v4.0'
      });
    };

    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/hu_HU/sdk/xfbml.customerchat.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    /* eslint-enable */
  },
};
</script>

<style scoped>
</style>
